<template>
	<div class="order">
		<List :page="page" @requestList="handleLoad">
			<OrderCell :orderList="orderList" :cellList="cellList">
				<template v-slot:region="{ item }">
					<template v-if="item.customerOrg">
						<p v-for="org in item.customerOrg" :key="org.id">{{ org.orgName }}</p>
					</template>
				</template>
			</OrderCell>
		</List>
	</div>
</template>

<script>
import List from '@/components/list';
import OrderCell from '@/components/order/cell';
import { getLearnedCourseList } from '@/api/customer';
import { writeOffStatus } from '@/filters';

export default {
	name: 'CustomerLearned',
	components: { List, OrderCell },
	data() {
		const { customerId } = this.$route.query;
		return {
			showDatePicker: false,
			orderList: [],
			cellList: [
				{ title: '客户姓名', value: 'customerName' },
				{ title: '订单编号', value: 'orderNo'},
				{ title: '课程名称', value: 'courseName'},
				{ title: '课程时间', value: 'courseDate' },
				{ title: '核销时间', value: 'courseWriteOffTime' },
				{ title: '核销状态', value: 'writeOffStatus' ,filter:writeOffStatus}
			],
			page: {
				currentPage: 1,
				currentCount: 10,
				totalCount: 0,
				totalPage: 0
			},
			params: {
				customerId: customerId ? Number(customerId) : undefined
			},
		};
	},
	mounted() {
		const params = {
			...this.params,
			page: this.page.currentPage,
			count: this.page.currentCount
		};
		this.getLearnedCourseList(params);
	},
	methods: {
		handleLoad() {
			console.log(123)
			const params = {
				...this.params,
				page: this.page.currentPage + 1,
				count: this.page.currentCount
			};
			this.getLearnedCourseList(params);
		},
		getLearnedCourseList(params) {
			getLearnedCourseList(params).then(res => {
				if (res.errcode === 0) {
					this.orderList = this.orderList.concat(res.data);
					console.log(this.orderList)
					this.page = res.page;
				}
			});
		}
	}
};
</script>

<style lang="less" scoped>
.order {
	&-nav {
		&-title {
			.van-cell__value {
				color: #333;
			}
			.van-icon-arrow-down {
				line-height: 24px;
				margin-left: 10px;
				color: #969799;
				font-size: 20px;
				font-weight: bold;
			}
		}
	}
}
.popup {
	padding: 15px;
}
</style>
